// src/components/FeatureRoute.jsx
// Pagina di una sezione acquistabile (gara, allenamento): se il cliente non
// l'ha attiva, al posto della pagina c'è un messaggio. L'admin passa sempre.
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Icon } from './icons';
import { useSession, canUse } from '../session';

const NAMES = { race: 'Gara', training: 'Allenamento' };

export default function FeatureRoute({ feature, children }) {
  const session = useSession();
  const navigate = useNavigate();
  if (canUse(feature, session)) return children;
  return (
    <div className="rs-page">
      <div className="rs-empty">
        <Icon.Lock />
        <strong>Sezione {NAMES[feature] || feature} non attiva</strong>
        <p>Questa sezione non è inclusa nel tuo account. Per attivarla contatta RaceSense.</p>
        <button type="button" className="rs-btn rs-btn--sm" onClick={() => navigate('/')}>Torna alla dashboard</button>
      </div>
    </div>
  );
}
